import {
  enCA_apacTranslations,
  enCA_checkoutTranslations,
  enCA_defaultTranslations,
  enCA_rbcTranslations,
  enCA_rbcProvidedTranslations,
  frCA_apacTranslations,
  frCA_checkoutTranslations,
  frCA_defaultTranslations,
  frCA_rbcTranslations,
  frCA_rbcProvidedTranslations,
  en_rbcTranslations,
} from "@hopper-b2b/i18n";
import { TranslationLanguage } from "@hopper-b2b/types";
import { merge } from "lodash-es";

/** Some configurations don't need a review from translations team
 * If you want to override any of them, add them as an attribute in this object
 */
const translation = {
  [TranslationLanguage["en-CA"]]: merge(
    enCA_defaultTranslations,
    enCA_apacTranslations,
    enCA_checkoutTranslations,
    en_rbcTranslations,
    enCA_rbcTranslations,
    enCA_rbcProvidedTranslations
  ),
  [TranslationLanguage["fr-CA"]]: merge(
    frCA_defaultTranslations,
    frCA_apacTranslations,
    frCA_checkoutTranslations,
    frCA_rbcTranslations,
    frCA_rbcProvidedTranslations
  ),
};

export default translation;
